var _ = require('underscore/underscore.js');

var template = require('./SubmissionFormSubmitterInfo.jinja');
require('./SubmissionFormSubmitterInfo.less');

var SubmissionFormBlock = require('./SubmissionFormBlock');

module.exports = SubmissionFormBlock.extend({

    template: template,

    events: {
        'change .SubmissionFormElement-checkbox': 'onCheckboxChange',
        'click .SubmissionFormSubmitterInfo-copy': 'onCopyClick'
    },

    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'onGetHeadInfo');

        app.vent.on('submission-head-info', this.onGetHeadInfo);

        SubmissionFormBlock.prototype.initialize.call(this, options);
    },


    deactivate: function (params) {
        app.vent.off('submission-head-info', this.onGetHeadInfo);

        return SubmissionFormBlock.prototype.deactivate.call(this, params);
    },


    onCopyClick: function () {
        app.vent.trigger('submission-get-head-info');
    },


    onGetHeadInfo: function (data) {
        _.each(data, function (value, key) {
            this.$('input[name="' + key + '"]').val(value);
        }.bind(this));
    },


    onCheckboxChange: function (e) {
        var $checkbox = $(e.currentTarget);
        var checked = $checkbox.is(':checked');

        this.$('.SubmissionFormElement-inputLine--conditional').toggleClass('SubmissionFormElement-inputLine--hidden', checked);
    },


    checkRequired: function () {
        return SubmissionFormBlock.prototype.checkRequired.call(this);
    },


    getFormData: function () {
        return {
            'submittedBy': {
                'name': this.$('input[name="name"]').val(),
                'company': this.$('input[name="company"]').val(),
                'phone': this.$('input[name="phone"]').val(),
                'email': this.$('input[name="email"]').val(),
                'address': this.$('input[name="address"]').val(),
                'address2': this.$('input[name="address2"]').val(),
                'city': this.$('input[name="city"]').val(),
                'state': this.$('input[name="state"]').val(),
                'zip': this.$('input[name="zip"]').val(),
                'country': this.$('input[name="country"]').val(),
                'comments': this.$('textarea[name="comments"]').val()
            }
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionFormSubmitterInfo.js
// module id = 123
// module chunks = 0